import React, { useEffect, useState } from 'react';
import { Modal } from 'react-native';
import { SafeAreaProvider, initialWindowMetrics } from 'react-native-safe-area-context';
import { Paywall } from './Paywall';
import { usePaywallStore } from '../store/paywallStore';
import { getCurrentPlan } from '../services/profile';
import type { Plan } from '../types';

// Repli quand les métriques natives ne sont pas dispo (ex. tests) : sans ça SafeAreaProvider
// ne rend pas ses enfants tant qu'il n'a pas mesuré le layout.
const FALLBACK_METRICS = {
  frame: { x: 0, y: 0, width: 0, height: 0 },
  insets: { top: 0, left: 0, right: 0, bottom: 0 },
};

// Modal racine du Paywall : monté une fois dans App.tsx, piloté par le store global.
export function PaywallModal() {
  const visible = usePaywallStore((s) => s.visible);
  const feature = usePaywallStore((s) => s.feature);
  const reason = usePaywallStore((s) => s.reason);
  const close = usePaywallStore((s) => s.close);
  const [plan, setPlan] = useState<Plan>('free');

  // Rend le plan SERVEUR relu : le Paywall s'en sert pour confirmer l'achat. L'erreur remonte
  // volontairement — une lecture ratée doit compter « pas encore confirmé », pas « free ».
  const refreshPlan = async (): Promise<Plan> => {
    const lu = await getCurrentPlan();
    setPlan(lu);
    return lu;
  };

  useEffect(() => {
    if (!visible) return;
    let active = true;
    getCurrentPlan()
      .then((p) => {
        if (active) setPlan(p);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [visible]);

  return (
    <Modal visible={visible} animationType="slide" onRequestClose={close}>
      {/* Le Modal RN est une hiérarchie native séparée : son propre SafeAreaProvider pour que
          les insets (encoche / barre d'état) fonctionnent dans le Paywall. */}
      {visible ? (
        <SafeAreaProvider initialMetrics={initialWindowMetrics ?? FALLBACK_METRICS}>
          <Paywall
            currentPlan={plan}
            feature={feature}
            reason={reason}
            onClose={close}
            onPurchased={refreshPlan}
            testID="paywall"
          />
        </SafeAreaProvider>
      ) : null}
    </Modal>
  );
}
